import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=4105fc24&scoped=true&"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuItems.vue?vue&type=style&index=0&id=4105fc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4105fc24",
  null
  
)

export default component.exports